module.exports = "https://static-www.niulinkcloud.com/_next/static/media/icon3.8407dd13cf160caee783a2b7a07c65ff.png";